import React, { Component } from "react";

import { Link, withRouter } from "react-router-dom";

import style from "./LandingPage.module.css";

import logo from "../../assets/Images/logo.png";

import { getPlainToken } from "../../assets/Js/tokenHandler";
import { marketPlaceParam } from "../../assets/Js/paramName";

const paramEnum = {
  gym: "gymaccount",
  athlete: "athleteaccount",
  login: "login",
};

export default withRouter(
  class LandingPage extends Component {
    constructor(props) {
      super(props);

      this.state = {
        paramType: '',
        search: "",
      };
    }

    componentDidMount() {
      const paramName = marketPlaceParam;
      const search = this.props.location.search;
      const paramValue = new URLSearchParams(search).get(paramName);

      this.setState(
        {
          search: search,
        },
        () => {
          this.checkIfUserIsLoggedIn();
        }
      );
    }

    checkIfUserIsLoggedIn = () => {
      const paramName = marketPlaceParam;
      const { search } = this.state;
      const paramValue = new URLSearchParams(search).get(paramName);

      if (getPlainToken()) {
        if (paramValue) {
          this.gotoToSpecificRoute(`/dashboard${search}`);
        } else {
          this.gotoToSpecificRoute("/dashboard");
        }
      }
    };

    whereToRedirect = () => {
      const { paramType, search } = this.state;

      if (search) {
        if (paramType === paramEnum.login) {
          this.gotoToSpecificRoute(`/login${search}`);
        } else if (paramType === paramEnum.gym) {
          this.gotoToSpecificRoute(`/registrationform/${paramType}${search}`);
        } else if (paramType === paramEnum.athlete) {
          this.gotoToSpecificRoute(`/registrationform/${paramType}${search}`);
        }
      } else {
        if (paramType === paramEnum.login) {
          this.gotoToSpecificRoute("/login");
        } else {
          this.gotoToSpecificRoute(`/registrationform/${paramType}`);
        }
      }
    };

    gotoToSpecificRoute = (route) => {
      this.props.history.push(route);
    };

    loginClickHanlder = () => {
      this.setState(
        {
          paramType: paramEnum.login,
        },
        () => {
          this.whereToRedirect();
        }
      );
    };

    render() {
      return (
        <React.Fragment>
          <div className="cornerBtnStyle">
            <a to="/login" className="text-white">
              <button className="basicBtnStyle secondaryBtn">Login</button>
            </a>
          </div>
          <div className={style.container}>
            <div className={`${style.formContainer} shadow`}>
              <div className="logo mt-3">
                <img src={logo} className="w-100" alt="not found" />
              </div>
              <hr />
              <div className="p-3">
                <div className="row">
                  <div className="col-md-6">
                <div className={`form-check ${style.formCheckHover} ${this.state.paramType === paramEnum.athlete ? "border-primary":""} `} style={{border: "1px solid lightgray",height: "100%", borderRadius: "10px"}}>
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      onClick={() => {
                        this.setState({
                          paramType: paramEnum.athlete,
                        });
                      }}
                    />
                    <b>Create Athlete Account</b>
                    <i
                      className={`${
                        this.state.paramType === paramEnum.athlete
                          ? `${style.checkedBtn}`
                          : `${style.uncheckedBtn}`
                      }`}
                    ></i>
                    <p className="text-secondary">
                      Join a gym, view record scores, and more!
                    </p>
                  </label>
                </div>
                </div>
                <div className="col-md-6">
                <div className={`form-check ${style.formCheckHover}  ${this.state.paramType === paramEnum.gym ? "border-primary":""} `} style={{border: "1px solid lightgray",height: "100%", borderRadius: "10px"}}>
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      onClick={() => {
                        this.setState({ paramType: paramEnum.gym });
                      }}
                    />
                    <b>Create Gym Account</b>
                    <i
                      className={`${
                        this.state.paramType === paramEnum.gym
                          ? `${style.checkedBtn}`
                          : `${style.uncheckedBtn}`
                      }`}
                    ></i>
                    <p className="text-secondary">
                      Post workouts, collect payments, interact with your
                      athletes, and much more!
                    </p>
                  </label>
                </div>
                </div>
                </div>
                <div className="mx-auto mt-3 width-fit-content">
                  <button
                    className={`basicBtnStyle primaryBtn`} 
                    onClick={this.whereToRedirect}
                    disabled={this.state.paramType=== '' ? true : false}
                  >
                    Next
                  </button>
                </div>
                <div className="h6 text-center mt-4 pointerCursor">
                Already have an account?
                <Link onClick={this.loginClickHanlder}>
                   <span className="primaryColor"> Log In</span> 
                    </Link>
                  </div>
              </div>
            </div>
          </div>
          <div className="cornerBtnStyle">
            <Link to="/marketplace" className="text-white">
              <button className="basicBtnStyle secondaryBtn">
                Marketplace
              </button>
            </Link>
          </div>
        </React.Fragment>
      );
    }
  }
);
